import { getChannelObj, formatTitleAndChannel } from '@/utils/channels';

export function getTitlesAndChannels(pageIds, pages) {
  const result = [];
  pageIds.forEach((pageId) => {
    const page = pages.find((page) => page.id === pageId);
    if (!page) {
      return;
    }

    const { title, channel } = page;
    const object = formatTitleAndChannel({
      title,
      channel: getChannelObj(channel).name,
    });

    result.push(object);
  });
  return result;
}
